import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Slider, Typography, FormControl, RadioGroup, FormControlLabel, Radio, Checkbox, IconButton, Divider } from '@material-ui/core'
import ColorLensIcon from '@material-ui/icons/ColorLens'
import { HexColorPicker } from 'react-colorful'
import clsx from 'clsx'
import { SecaoGenerica } from 'components'
import { useStyles } from './FormDadosCaracteristicos.styles'

const marcosPele = [
  { value: 0, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Vermelha</span> },
  { value: 0.25, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Amarela</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Branca</span> },
  { value: 0.75, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Parda</span> },
  { value: 1, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Preta</span> },
]

const marcosOlhos = [
  { value: 0, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Azul</span> },
  { value: 0.25, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Verde</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Avelã</span> },
  { value: 0.75, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Castanha</span> },
  { value: 1, label: <span style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>Preta</span> },
]

const marcosTipoCabelo = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Liso</span> },
  { value: 0.33, label: <span style={{ fontSize: '11px' }}>Ondulado</span> },
  { value: 0.66, label: <span style={{ fontSize: '11px' }}>Encaracolado</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Crespo</span> },
]

const marcosQuantidadeCabelo = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Ausente</span> },
  { value: 0.33, label: <span style={{ fontSize: '11px' }}>Baixo</span> },
  { value: 0.66, label: <span style={{ fontSize: '11px' }}>Curto</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Longo</span> },
]

const marcosSobrancelha = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Arqueada</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Semiarqueada</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Reta</span> },
]

const marcosLarguraNariz = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Leptorrino</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Mesorrino</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Platirrino</span> },
]

const marcosPontaNariz = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Para cima</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Horizontal</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Para baixo</span> },
]

const marcosDorsoNariz = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Cavado</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Reto</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Curvado</span> },
]

const marcosLabios = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Finos</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Médios</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Grossos</span> },
]

const marcosBoca = [
  { value: 0, label: <span style={{ fontSize: '11px' }}>Pequena</span> },
  { value: 0.5, label: <span style={{ fontSize: '11px' }}>Média</span> },
  { value: 1, label: <span style={{ fontSize: '11px' }}>Grande</span> },
]

const marcosFormatoRosto = [
  { value: 0, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Quadrado</span> },
  { value: 0.17, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Retangular</span> },
  { value: 0.34, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Oval</span> },
  { value: 0.51, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Redondo</span> },
  { value: 0.68, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Piramidal</span> },
  { value: 0.85, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Hexagonal</span> },
  { value: 1, label: <span style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>Triangular</span> },
]

export const FormDadosCaracteristicos = (props) => {
  const { formData, handleChange, handleChangeComArredondamento, route } = props
  const classes = useStyles()

  return (
    <div className={classes.container}>

      {/* Grupo 1: Pele e Aspectos Gerais */}
      <SecaoGenerica titulo="Pele e Aspectos Gerais" spacing={3}>
        {/* Cor da pele */}
        <Grid item xs={12} sm={6} md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.corPeleChecked}
              onChange={(e) => handleChange('corPeleChecked', e.target.checked)}
              name="corPeleChecked"
              color="primary"
            />
            Cor da pele
          </Typography>
          <div className={classes.sliderVerticalWrapper}>
            <div
              className={clsx(
                classes.gradientBar,
                classes.skinGradient,
                formData.corPeleChecked ? classes.enabledGradient : classes.disabledGradient
              )}
            />
            <div className={classes.sliderVerticalContainer}>
              <Slider
                disabled={!formData.corPeleChecked}
                min={0}
                max={1}
                step={route.origem === 'NECRODONTOSCOPICO' ? 0.25 : 0.01}
                orientation="vertical"
                value={formData.corPele}
                marks={marcosPele}
                onChange={(e, value) => handleChange('corPele', value)}
                className={classes.sliderVertical}
              />
            </div>
          </div>
        </Grid>

        {/* Carbonizado */}
        <Grid item xs={12} sm={6} md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.carbonizadoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.carbonizadoChecked}
              onChange={(e) => handleChange('carbonizadoChecked', e.target.checked)}
              name="carbonizadoChecked"
              color="primary"
            />
            Carbonizado
          </Typography>
          <FormControl component="fieldset" disabled={!formData.carbonizadoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="carbonizado"
              name="carbonizado"
              value={formData.carbonizado}
              onChange={(event, newValue) => handleChange('carbonizado', newValue)}
            >
              <FormControlLabel value="Sim" control={<Radio color="primary" />} label="Sim" />
              <FormControlLabel value="Não" control={<Radio color="primary" />} label="Não" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Em decomposição */}
        <Grid item xs={12} sm={6} md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.emDecomposicaoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.emDecomposicaoChecked}
              onChange={(e) => handleChange('emDecomposicaoChecked', e.target.checked)}
              name="emDecomposicaoChecked"
              color="primary"
            />
            Em decomposição
          </Typography>
          <FormControl component="fieldset" disabled={!formData.emDecomposicaoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="emDecomposicao"
              name="emDecomposicao"
              value={formData.emDecomposicao}
              onChange={(event, newValue) => handleChange('emDecomposicao', newValue)}
            >
              <FormControlLabel value="Sim" control={<Radio color="primary" />} label="Sim" />
              <FormControlLabel value="Não" control={<Radio color="primary" />} label="Não" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Cianose facial */}
        <Grid item xs={12} sm={6} md={3} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.cianoseFacialChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.cianoseFacialChecked}
              onChange={(e) => handleChange('cianoseFacialChecked', e.target.checked)}
              name="cianoseFacialChecked"
              color="primary"
            />
            Cianose facial
          </Typography>
          <FormControl component="fieldset" disabled={!formData.cianoseFacialChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="cianoseFacial"
              name="cianoseFacial"
              value={formData.cianoseFacial}
              onChange={(event, newValue) => handleChange('cianoseFacial', newValue)}
            >
              <FormControlLabel value="Sim" control={<Radio color="primary" />} label="Sim" />
              <FormControlLabel value="Não" control={<Radio color="primary" />} label="Não" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </SecaoGenerica>

      {/* Grupo 2: Olhos e Face */}
      <SecaoGenerica titulo="Olhos e Face" spacing={3}>
        {/* Cor da Íris */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.corIrisChecked}
              onChange={(e) => handleChange('corIrisChecked', e.target.checked)}
              name="corIrisChecked"
              color="primary"
            />
            Cor da Íris
          </Typography>
          <div className={classes.sliderVerticalWrapper}>
            <div
              className={clsx(
                classes.gradientBar,
                classes.eyeGradient,
                formData.corIrisChecked ? classes.enabledGradient : classes.disabledGradient
              )}
            />
            <div className={classes.sliderVerticalContainer}>
              <Slider
                disabled={!formData.corIrisChecked}
                min={0}
                max={1}
                step={route.origem === 'NECRODONTOSCOPICO' ? 0.25 : 0.01}
                orientation="vertical"
                value={formData.corIris}
                marks={marcosOlhos}
                onChange={(e, value) => handleChange('corIris', value)}
                className={classes.sliderVertical}
              />
            </div>
          </div>
        </Grid>

        {/* Pupilas */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.pupilasChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.pupilasChecked}
              onChange={(e) => handleChange('pupilasChecked', e.target.checked)}
              name="pupilasChecked"
              color="primary"
            />
            Pupilas
          </Typography>
          <FormControl component="fieldset" disabled={!formData.pupilasChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="pupilas"
              name="pupilas"
              value={formData.pupilas}
              onChange={(event, newValue) => handleChange('pupilas', newValue)}
            >
              <FormControlLabel value="Midríacas" control={<Radio color="primary" />} label="Midríacas" />
              <FormControlLabel value="Mióticas" control={<Radio color="primary" />} label="Mióticas" />
              <FormControlLabel value="Anisocóricas" control={<Radio color="primary" />} label="Anisocóricas" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Conjuntiva */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.conjuntivaChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.conjuntivaChecked}
              onChange={(e) => handleChange('conjuntivaChecked', e.target.checked)}
              name="conjuntivaChecked"
              color="primary"
            />
            Conjuntiva
          </Typography>
          <FormControl component="fieldset" disabled={!formData.conjuntivaChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="conjuntiva"
              name="conjuntiva"
              value={formData.conjuntiva}
              onChange={(event, newValue) => handleChange('conjuntiva', newValue)}
            >
              <FormControlLabel value="Brilhante" control={<Radio color="primary" />} label="Brilhante" />
              <FormControlLabel value="Hiperemiada" control={<Radio color="primary" />} label="Hiperemiada" />
              <FormControlLabel value="Opacas" control={<Radio color="primary" />} label="Opacas" />
              <FormControlLabel value="Preta" control={<Radio color="primary" />} label="Preta" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Pálpebras */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.palpebrasChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.palpebrasChecked}
              onChange={(e) => handleChange('palpebrasChecked', e.target.checked)}
              name="palpebrasChecked"
              color="primary"
            />
            Pálpebras
          </Typography>
          <FormControl component="fieldset" disabled={!formData.palpebrasChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="palpebras"
              name="palpebras"
              value={formData.palpebras}
              onChange={(event, newValue) => handleChange('palpebras', newValue)}
            >
              <FormControlLabel value="Fechadas" control={<Radio color="primary" />} label="Fechadas" />
              <FormControlLabel value="Abertas" control={<Radio color="primary" />} label="Abertas" />
              <FormControlLabel value="Semiabertas" control={<Radio color="primary" />} label="Semiabertas" />
              <FormControlLabel value="Saturadas" control={<Radio color="primary" />} label="Saturadas" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Arco Senil */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.arcoSenilChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.arcoSenilChecked}
              onChange={(e) => handleChange('arcoSenilChecked', e.target.checked)}
              name="arcoSenilChecked"
              color="primary"
            />
            Arco Senil
          </Typography>
          <FormControl component="fieldset" disabled={!formData.arcoSenilChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="arcoSenil"
              name="arcoSenil"
              value={formData.arcoSenil}
              onChange={(event, newValue) => handleChange('arcoSenil', newValue)}
            >
              <FormControlLabel value="Presente" control={<Radio color="primary" />} label="Presente" />
              <FormControlLabel value="Ausente" control={<Radio color="primary" />} label="Ausente" />
              <FormControlLabel value="Não visualizado" control={<Radio color="primary" />} label="Não visualizado" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Formato do Rosto em largura total */}
        <Grid item xs={12}>
          <Divider className={classes.divider} />
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.formatoRostoChecked}
              onChange={(e) => handleChange('formatoRostoChecked', e.target.checked)}
              name="formatoRostoChecked"
              color="primary"
            />
            Formato do rosto
          </Typography>
          <div className={classes.imageScaleContainer}>
            <img
              alt="Escala formato do rosto"
              src="/images/formatoRosto.jpeg"
              className={clsx(
                classes.scaleImage,
                formData.formatoRostoChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
              style={{ maxHeight: '110px' }}
            />
            <div className={classes.sliderHorizontalContainer}>
              <Slider
                disabled={!formData.formatoRostoChecked}
                min={0}
                max={1}
                step={0.17}
                value={formData.formatoRosto || 0}
                marks={marcosFormatoRosto}
                onChange={(e, value) => handleChangeComArredondamento('formatoRosto', value)}
              />
            </div>
          </div>
        </Grid>
      </SecaoGenerica>

      {/* Grupo 3: Cabelos e Pelos Faciais */}
      <SecaoGenerica titulo="Cabelos e Pelos Faciais" spacing={3}>
        {/* Cor do Cabelo */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <div className={classes.colorPickerHeader}>
            <Typography className={classes.titleCheckboxLabel}>
              <Checkbox
                checked={formData.corCabeloChecked}
                onChange={(e) => handleChange('corCabeloChecked', e.target.checked)}
                name="corCabeloChecked"
                color="primary"
              />
              Cor do cabelo
            </Typography>
            <IconButton
              disabled={!formData.corCabeloChecked}
              onClick={() => handleChange('corCabeloColorPicker', !formData.corCabeloColorPicker)}
              size="small"
            >
              <ColorLensIcon color={formData.corCabeloChecked ? "primary" : "disabled"} />
            </IconButton>
          </div>
          <div className={classes.hairColorContainer}>
            {formData.corCabeloColorPicker && formData.corCabeloChecked ? (
              <HexColorPicker color={formData.corCabelo} onChange={(value) => handleChange('corCabelo', value)} />
            ) : (
              <FormControl disabled={!formData.corCabeloChecked} component="fieldset">
                <RadioGroup
                  aria-label="corCabelo"
                  name="corCabelo"
                  value={formData.corCabelo}
                  onChange={(event, newValue) => handleChange('corCabelo', newValue)}
                >
                  <FormControlLabel value="Loiro" control={<Radio color="primary" />} label="Loiro" />
                  <FormControlLabel value="Castanho" control={<Radio color="primary" />} label="Castanho" />
                  <FormControlLabel value="Vermelho" control={<Radio color="primary" />} label="Vermelho" />
                  <FormControlLabel value="Preto" control={<Radio color="primary" />} label="Preto" />
                  <FormControlLabel value="Grisalho" control={<Radio color="primary" />} label="Grisalho" />
                </RadioGroup>
              </FormControl>
            )}
          </div>
        </Grid>

        {/* Tipo de cabelo */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.tipoCabeloChecked}
              onChange={(e) => handleChange('tipoCabeloChecked', e.target.checked)}
              name="tipoCabeloChecked"
              color="primary"
            />
            Tipo do cabelo
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala tipo de cabelo"
              src="/images/fios_escala.png"
              className={clsx(
                classes.scaleImageHair,
                formData.tipoCabeloChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.tipoCabeloChecked}
                min={0}
                max={1}
                step={0.33}
                value={formData.tipoCabelo}
                marks={marcosTipoCabelo}
                onChange={(e, value) => handleChangeComArredondamento('tipoCabelo', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Quantidade de cabelo */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.quantidadeCabeloChecked}
              onChange={(e) => handleChange('quantidadeCabeloChecked', e.target.checked)}
              name="quantidadeCabeloChecked"
              color="primary"
            />
            Quantidade de cabelo
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala quantidade de cabelo"
              src="/images/cabelo_quantidade_escala.png"
              className={clsx(
                classes.scaleImageHair,
                formData.quantidadeCabeloChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.quantidadeCabeloChecked}
                min={0}
                max={1}
                step={0.33}
                value={formData.quantidadeCabelo}
                marks={marcosQuantidadeCabelo}
                onChange={(e, value) => handleChangeComArredondamento('quantidadeCabelo', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Sobrancelha */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.sobrancelhaChecked}
              onChange={(e) => handleChange('sobrancelhaChecked', e.target.checked)}
              name="sobrancelhaChecked"
              color="primary"
            />
            Sobrancelha
          </Typography>
          <div className={classes.sliderScaleVerticalWrapper}>
            <img
              alt="Escala sobrancelha"
              src="/images/escala_sobrancelha.png"
              className={clsx(
                classes.scaleImageVertical,
                formData.sobrancelhaChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div style={{ height: '110px', display: 'flex', alignItems: 'center' }}>
              <Slider
                disabled={!formData.sobrancelhaChecked}
                min={0}
                max={1}
                step={0.5}
                orientation="vertical"
                value={formData.sobrancelha}
                marks={marcosSobrancelha}
                onChange={(e, value) => handleChange('sobrancelha', value)}
                className={classes.sliderVertical}
                style={{ height: '100px' }}
              />
            </div>
          </div>
        </Grid>

        {/* Barba */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.barbaChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.barbaChecked}
              onChange={(e) => handleChange('barbaChecked', e.target.checked)}
              name="barbaChecked"
              color="primary"
            />
            Barba
          </Typography>
          <FormControl component="fieldset" disabled={!formData.barbaChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="barba"
              name="barba"
              value={formData.barba}
              onChange={(event, newValue) => handleChange('barba', newValue)}
            >
              <Grid container spacing={1}>
                <Grid item xs={6}><FormControlLabel value="Por fazer" control={<Radio color="primary" size="small" />} label="Por fazer" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Rala" control={<Radio color="primary" size="small" />} label="Rala" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Farta" control={<Radio color="primary" size="small" />} label="Farta" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Cavanhaque" control={<Radio color="primary" size="small" />} label="Cavanhaque" /></Grid>
                <Grid item xs={12}><FormControlLabel value="Ausente" control={<Radio color="primary" size="small" />} label="Ausente" /></Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Bigode */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.bigodeChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.bigodeChecked}
              onChange={(e) => handleChange('bigodeChecked', e.target.checked)}
              name="bigodeChecked"
              color="primary"
            />
            Bigode
          </Typography>
          <FormControl component="fieldset" disabled={!formData.bigodeChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="bigode"
              name="bigode"
              value={formData.bigode}
              onChange={(event, newValue) => handleChange('bigode', newValue)}
            >
              <FormControlLabel value="Presente" control={<Radio color="primary" size="small" />} label="Presente" />
              <FormControlLabel value="Ausente" control={<Radio color="primary" size="small" />} label="Ausente" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </SecaoGenerica>

      {/* Grupo 4: Nariz e Orelhas */}
      <SecaoGenerica titulo="Nariz e Orelhas" spacing={3}>
        {/* Largura do Nariz */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.larguraNarizChecked}
              onChange={(e) => handleChange('larguraNarizChecked', e.target.checked)}
              name="larguraNarizChecked"
              color="primary"
            />
            Largura do nariz
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala largura do nariz"
              src="/images/escala_largura_nariz.png"
              className={clsx(
                classes.scaleImageHair,
                formData.larguraNarizChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.larguraNarizChecked}
                min={0}
                max={1}
                step={0.5}
                value={formData.larguraNariz}
                marks={marcosLarguraNariz}
                onChange={(e, value) => handleChangeComArredondamento('larguraNariz', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Ponta do Nariz */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.pontaNarizChecked}
              onChange={(e) => handleChange('pontaNarizChecked', e.target.checked)}
              name="pontaNarizChecked"
              color="primary"
            />
            Ponta do nariz
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala ponta do nariz"
              src="/images/escala_ponta_nariz.png"
              className={clsx(
                classes.scaleImageHair,
                formData.pontaNarizChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.pontaNarizChecked}
                min={0}
                max={1}
                step={0.5}
                value={formData.pontaNariz}
                marks={marcosPontaNariz}
                onChange={(e, value) => handleChange('pontaNariz', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Dorso do Nariz */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.dorsoNarizChecked}
              onChange={(e) => handleChange('dorsoNarizChecked', e.target.checked)}
              name="dorsoNarizChecked"
              color="primary"
            />
            Dorso do nariz
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala dorso do nariz"
              src="/images/dorso_nariz.png"
              className={clsx(
                classes.scaleImageHair,
                formData.dorsoNarizChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.dorsoNarizChecked}
                min={0}
                max={1}
                step={0.5}
                value={formData.dorsoNariz}
                marks={marcosDorsoNariz}
                onChange={(e, value) => handleChangeComArredondamento('dorsoNariz', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Lóbulo orelha esquerda */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.lobuloOrelhaEsquerdaChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.lobuloOrelhaEsquerdaChecked}
              onChange={(e) => handleChange('lobuloOrelhaEsquerdaChecked', e.target.checked)}
              name="lobuloOrelhaEsquerdaChecked"
              color="primary"
            />
            Lóbulo orelha esquerda
          </Typography>
          <FormControl component="fieldset" disabled={!formData.lobuloOrelhaEsquerdaChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="lobuloOrelhaEsquerda"
              name="lobuloOrelhaEsquerda"
              value={formData.lobuloOrelhaEsquerda}
              onChange={(event, newValue) => handleChange('lobuloOrelhaEsquerda', newValue)}
              row
            >
              <FormControlLabel value="Solto" control={<Radio color="primary" />} label="Solto" />
              <FormControlLabel value="Preso" control={<Radio color="primary" />} label="Preso" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Lóbulo orelha direita */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.lobuloOrelhaDireitaChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.lobuloOrelhaDireitaChecked}
              onChange={(e) => handleChange('lobuloOrelhaDireitaChecked', e.target.checked)}
              name="lobuloOrelhaDireitaChecked"
              color="primary"
            />
            Lóbulo orelha direita
          </Typography>
          <FormControl component="fieldset" disabled={!formData.lobuloOrelhaDireitaChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="lobuloOrelhaDireita"
              name="lobuloOrelhaDireita"
              value={formData.lobuloOrelhaDireita}
              onChange={(event, newValue) => handleChange('lobuloOrelhaDireita', newValue)}
              row
            >
              <FormControlLabel value="Solto" control={<Radio color="primary" />} label="Solto" />
              <FormControlLabel value="Preso" control={<Radio color="primary" />} label="Preso" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </SecaoGenerica>

      {/* Grupo 5: Boca, Mandíbula e Dentição */}
      <SecaoGenerica titulo="Boca, Mandíbula e Dentição" spacing={3}>
        {/* Lábios */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.labiosChecked}
              onChange={(e) => handleChange('labiosChecked', e.target.checked)}
              name="labiosChecked"
              color="primary"
            />
            Lábios
          </Typography>
          <div className={classes.sliderScaleVerticalWrapper}>
            <img
              alt="Escala lábios"
              src="/images/labios.png"
              className={clsx(
                classes.scaleImageVertical,
                formData.labiosChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div style={{ height: '110px', display: 'flex', alignItems: 'center' }}>
              <Slider
                disabled={!formData.labiosChecked}
                min={0}
                max={1}
                step={0.5}
                orientation="vertical"
                value={formData.labios}
                marks={marcosLabios}
                onChange={(e, value) => handleChange('labios', value)}
                className={classes.sliderVertical}
                style={{ height: '100px' }}
              />
            </div>
          </div>
        </Grid>

        {/* Boca */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel}>
            <Checkbox
              checked={formData.bocaChecked}
              onChange={(e) => handleChange('bocaChecked', e.target.checked)}
              name="bocaChecked"
              color="primary"
            />
            Boca
          </Typography>
          <div className={classes.sliderScaleWrapper}>
            <img
              alt="Escala boca"
              src="/images/boca.jpeg"
              className={clsx(
                classes.scaleImageHair,
                formData.bocaChecked ? classes.scaleImageEnabled : classes.scaleImageDisabled
              )}
            />
            <div className={classes.sliderHorizontalWrapper}>
              <Slider
                disabled={!formData.bocaChecked}
                min={0}
                max={1}
                step={0.5}
                value={formData.boca}
                marks={marcosBoca}
                onChange={(e, value) => handleChangeComArredondamento('boca', value)}
              />
            </div>
          </div>
        </Grid>

        {/* Rigidez buco-facial */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.rigidezBucoFacialChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.rigidezBucoFacialChecked}
              onChange={(e) => handleChange('rigidezBucoFacialChecked', e.target.checked)}
              name="rigidezBucoFacialChecked"
              color="primary"
            />
            Rigidez buco-facial
          </Typography>
          <FormControl component="fieldset" disabled={!formData.rigidezBucoFacialChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="rigidezBucoFacial"
              name="rigidezBucoFacial"
              value={formData.rigidezBucoFacial}
              onChange={(event, newValue) => handleChange('rigidezBucoFacial', newValue)}
            >
              <FormControlLabel value="Presente" control={<Radio color="primary" size="small" />} label="Presente" />
              <FormControlLabel value="Ausente" control={<Radio color="primary" size="small" />} label="Ausente" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Dentição */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.denticaoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.denticaoChecked}
              onChange={(e) => handleChange('denticaoChecked', e.target.checked)}
              name="denticaoChecked"
              color="primary"
            />
            Dentição
          </Typography>
          <FormControl component="fieldset" disabled={!formData.denticaoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="denticao"
              name="denticao"
              value={formData.denticao}
              onChange={(event, newValue) => handleChange('denticao', newValue)}
            >
              <FormControlLabel value="Decídua" control={<Radio color="primary" size="small" />} label="Decídua" />
              <FormControlLabel value="Mista" control={<Radio color="primary" size="small" />} label="Mista" />
              <FormControlLabel value="Permanente" control={<Radio color="primary" size="small" />} label="Permanente" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Protusão */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.protusaoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.protusaoChecked}
              onChange={(e) => handleChange('protusaoChecked', e.target.checked)}
              name="protusaoChecked"
              color="primary"
            />
            Protusão
          </Typography>
          <FormControl component="fieldset" disabled={!formData.protusaoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="protusao"
              name="protusao"
              value={formData.protusao}
              onChange={(event, newValue) => handleChange('protusao', newValue)}
            >
              <FormControlLabel value="NÃO" control={<Radio color="primary" size="small" />} label="Não" />
              <FormControlLabel value="Globos oculares" control={<Radio color="primary" size="small" />} label="Globos oculares" />
              <FormControlLabel value="Língua" control={<Radio color="primary" size="small" />} label="Língua" />
              <FormControlLabel value="Língua e globos oculares" control={<Radio color="primary" size="small" />} label="Língua/Globos" />
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Tratamento protético */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.tratamentoProteticoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.tratamentoProteticoChecked}
              onChange={(e) => handleChange('tratamentoProteticoChecked', e.target.checked)}
              name="tratamentoProteticoChecked"
              color="primary"
            />
            Tratamento protético
          </Typography>
          <FormControl component="fieldset" disabled={!formData.tratamentoProteticoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="tratamentoProtetico"
              name="tratamentoProtetico"
              value={formData.tratamentoProtetico}
              onChange={(event, newValue) => handleChange('tratamentoProtetico', newValue)}
            >
              <Grid container spacing={1}>
                <Grid item xs={6}><FormControlLabel value="Superior" control={<Radio color="primary" size="small" />} label="Superior" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Inferior" control={<Radio color="primary" size="small" />} label="Inferior" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Total" control={<Radio color="primary" size="small" />} label="Total" /></Grid>
                <Grid item xs={6}><FormControlLabel value="Parcial" control={<Radio color="primary" size="small" />} label="Parcial" /></Grid>
                <Grid item xs={12}><FormControlLabel value="Ausente" control={<Radio color="primary" size="small" />} label="Ausente" /></Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>

        {/* Tratamento ortodôntico */}
        <Grid item xs={12} sm={6} md={4} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginTop: '16px' }}>
          <Typography className={classes.titleCheckboxLabel} style={{ color: formData.tratamentoOrtodonticoChecked ? 'inherit' : 'rgba(0,0,0,0.38)' }}>
            <Checkbox
              checked={formData.tratamentoOrtodonticoChecked}
              onChange={(e) => handleChange('tratamentoOrtodonticoChecked', e.target.checked)}
              name="tratamentoOrtodonticoChecked"
              color="primary"
            />
            Tratamento ortodôntico
          </Typography>
          <FormControl component="fieldset" disabled={!formData.tratamentoOrtodonticoChecked} className={classes.formControl}>
            <RadioGroup
              aria-label="tratamentoOrtodontico"
              name="tratamentoOrtodontico"
              value={formData.tratamentoOrtodontico}
              onChange={(event, newValue) => handleChange('tratamentoOrtodontico', newValue)}
            >
              <FormControlLabel value="Superior" control={<Radio color="primary" size="small" />} label="Superior" />
              <FormControlLabel value="Inferior" control={<Radio color="primary" size="small" />} label="Inferior" />
              <FormControlLabel value="Ausente" control={<Radio color="primary" size="small" />} label="Ausente" />
            </RadioGroup>
          </FormControl>
        </Grid>
      </SecaoGenerica>

    </div>
  )
}

FormDadosCaracteristicos.propTypes = {
  formData: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleChangeComArredondamento: PropTypes.func.isRequired,
  route: PropTypes.shape({
    origem: PropTypes.string,
  }).isRequired,
}
